import React, { useState, useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import { useSnackbar } from 'notistack5'
import menu2Fill from '@iconify/icons-eva/menu-2-fill'
import { alpha, styled } from '@material-ui/core/styles'
import { Box, Stack, AppBar, Toolbar, IconButton, Typography, Container } from '@material-ui/core'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { MHidden } from '../../components/@material-extend'
//
import MenuIcon from '@mui/icons-material/Menu';
// import NotificationsPopover from './NotificationsPopover'
import storage from 'utils/storage'
import { SocketContext } from 'utils/context/socket'
import Logo from 'components/Logo'
// import {UsersContext} from 'utils/context/users'
const DRAWER_WIDTH = 0
const APPBAR_MOBILE = 40
const APPBAR_DESKTOP = 92

// Detect mobile platforms for proper spacing
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isAndroid = /Android/i.test(navigator.userAgent);

const DashboardNavbar = ({ open, onOpenSidebar, onOpenAdminSidebar, _data }) => {
  const navigation = useNavigate()
  const location = useLocation()
  const socket = useContext(SocketContext)
  const { enqueueSnackbar } = useSnackbar()
  // const {users, setUsers} = useContext(UsersContext)
  const [data, setData] = useState({
    users: [],
    employee: [],
    loading: false,
    online: 0,
  })

  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    // Use color-coded background instead of image for better performance
    background: data.users.role === 1 || data.users.role >= 3 ? 'transparent' : 'linear-gradient(135deg, #0657C9 0%, #13E9DD 100%)',
    position: 'fixed',
    color: 'white', // Text color
    // Reduced height and added mobile padding
    height: isMobile ? '90px' : '100px',
    width: '100%',
    minHeight: APPBAR_MOBILE,
    // Add safe area padding for mobile devices
    paddingTop: isMobile ? (isIOS ? '44px' : '24px') : '0px',
    [theme.breakpoints.up('lg')]: {
      minHeight: APPBAR_DESKTOP,
      padding: theme.spacing(0, 5),
    },
  }))

  const load = async () => {
    setData((p) => ({ ...p, loading: true }))
    const local_user = await storage.getUser()
    if (!local_user) return;
    const user = JSON.parse(local_user)
    let { _id, role } = user
    if (socket && (role === 1 || role === 3)) {
      socket.emit('get_users', { _id })
    }
    return setData((p) => ({ ...p, users: user, loading: false }))
  }

  const handleNavigateDashboard = () => {
    onOpenSidebar()
    navigation('/dashboard/app')
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

/*  useEffect(() => {
    socket.on('notification', async (notif) => {
      const local_user = await storage.getUser()
      if (!local_user) return;
      const user = JSON.parse(local_user)
      if (user.role === 1 || user.role === 4) {
        let { _id } = user
        socket.emit('get_users', { _id })
        enqueueSnackbar(notif?.description, {
          variant: 'info',
        })
      }
    })

    socket.on('receive_status', async (notif) => {
      const local_user = await storage.getUser()
      if (!local_user) return;
      const user = JSON.parse(local_user)
      if (user.role === 1 || user.role === 4) {
        let { _id } = user
        socket.emit('get_users', { _id })
        enqueueSnackbar(`${notif?.user} - ${notif?.status}`, {
          variant: 'info',
        })
      }
    })

    socket.on('users', async (users) => {
      if (!users) return console.log('error fetching users')

      const local_user = await storage.getUser()
      if (!local_user) return console.log('error current user')

      const index = users.findIndex((user) => user.uuid === user._id)
      if (index !== -1) {
        return users.splice(index, 1)[0]
      }

      return setData((p) => ({ ...p, online: users.length }))
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, enqueueSnackbar])*/

  // Check if current page is QR scan page
  const isQRScanPage = location.pathname === '/stores/biometric'

  return (
      <ToolbarStyle sx={{borderRadius: open ? '0 0 0 50px' : '0 0 50px 50px'}}>
        
        {/* Hamburger menu for QR scan page - positioned on the left */}
        {(data.users.role === 1 || data.users.role >= 3) && (
          <IconButton
            onClick={onOpenAdminSidebar}
            sx={{
              position: 'absolute',
              left: 16,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1000,
              color: 'black',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)'
              }
            }}
          >
            <MenuIcon sx={{ fontSize: 30 }} />
          </IconButton>
        )}
        {(location.pathname === '/dashboard/app/profile' || location.pathname === '/dashboard/app/my-company' || location.pathname === '/dashboard/app/required-documents' || location.pathname === '/dashboard/app/my-history') && (
          <IconButton
            onClick={() => handleNavigateDashboard()}
            sx={{
              color: 'text.primary',
              position: 'absolute',
              zIndex: 1000,
              mb: {xs: 6, sm: 0}
            }}
          >
            <ChevronLeftIcon sx={{color: 'white'}} fontSize='large' />
          </IconButton>
        )}
          <>
            {data.users.role === 0 || isQRScanPage
              ? 
                  <>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                  }}>
                      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <img src="/favicon/header-logo.png" alt="Dashboard Logo" style={{width: '65%', height: '65%'}} />
                        <Typography
                          variant="p" 
                          sx={{
                            fontSize: '0.80rem',
                            color: 'white',
                            mb: 1
                          }}
                        >
                          App Version: {process.env.REACT_APP_VERSION}
                        </Typography>
                      </Box>
                  </Box>
                  </>
              : 
                ''
            }
          </>
        {/* {(data.users.role === 1 || data.users.role >= 3) && (
          <MHidden width="lgUp">
            <IconButton onClick={onOpenAdminSidebar} sx={{ mr: 1, mb: { xs: 4, sm: 0 }, color: 'text.primary' }}>
              <Icon icon={menu2Fill} /> 
            </IconButton>
          </MHidden>
        )} */}
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }} mb={isMobile ? 4 : 0}>
          {(data.users.role === 1 || data.users.role >= 3) && (!isMobile && isQRScanPage || !isQRScanPage) ? (
            <>
              <h5 style={{ color: '#727272' }}>
                {data.online} Online {data.online && data.online > 0 ? 'Employees' : 'Employee'}
              </h5>
              {/* <NotificationsPopover /> */}
            </>
          ) : (
            ''
          )}

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={onOpenSidebar}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(33, 150, 243, 0.30)'
              },
              mr: 1,
            }}
          >
            <MenuIcon sx={{ color: '#2196f3', fontSize: 30 }} />
          </IconButton>
        </Stack>
      </ToolbarStyle>
  )
}

export default DashboardNavbar

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
}
